import * as i0 from '@angular/core';
import { Directive, Input, HostListener, NgModule } from '@angular/core';
import tippy from 'tippy.js';
import { CommonModule } from '@angular/common';
class TooltipDirective {
  constructor(el) {
    this.el = el;
    this.content = null;
    this.title = null;
    this.trigger = 'mouseenter focus';
    this.position = 'top';
    this.maxWidth = 350;
    this.interactive = true;
    this.closeOnOutsideClick = true;
    this.darkMode = false;
    this.arrow = false;
    this.overflowTooltip = false;
    this.appendTo = '';
    this.open = false;
    this.el = el;
  }
  ngAfterContentInit() {
    const popperOptions = {
      modifiers: [{
        name: 'arrow',
        options: {
          padding: 15
        }
      }]
    };
    this.height = this.el.nativeElement.getBoundingClientRect().height / 2 + 4;
    const appendToElement = typeof this.appendTo === 'string' && this.appendTo.trim() !== '' ? document.querySelector(this.appendTo) || this.el.nativeElement : this.appendTo || this.el.nativeElement;
    this.tippyOptions = {
      appendTo: appendToElement,
      arrow: this.arrow,
      trigger: this.trigger,
      interactive: this.interactive,
      placement: this.position,
      allowHTML: true,
      maxWidth: this.maxWidth,
      hideOnClick: this.closeOnOutsideClick,
      theme: this.darkMode ? 'dark' : 'light',
      popperOptions: popperOptions,
      offset: [0, this.height],
      onHide: () => {
        this.el.nativeElement.removeAttribute('aria-label');
        this.open = false;
      },
      onCreate: instance => {
        this.el.nativeElement.setAttribute('aria-describedby', `tippy-${instance.id}`);
      },
      onShow: instance => {
        if (this.popoverTemplate) {
          instance.setContent(this.popoverTemplate.content);
        } else if (this.content) {
          this.container = document.createElement('div');
          this.container.classList.add('sol-tooltip-container');
          if (this.title) {
            this.titleSpan = document.createElement('span');
            this.titleSpan.classList.add('sol-tooltip-title');
            this.titleSpan.append(this.title);
            this.container.append(this.titleSpan);
            this.container.append(document.createElement('br'));
          }
          this.contentSpan = document.createElement('span');
          this.contentSpan.classList.add('sol-tooltip-content');
          this.contentSpan.append(this.content);
          this.container.append(this.contentSpan);
          instance.setContent(this.container);
          this.el.nativeElement.setAttribute('aria-label', this.title + ' ' + this.content);
        }
        this.open = true;
      }
    };
    if (!this.overflowTooltip) {
      this.instance = tippy(this.el.nativeElement, this.tippyOptions);
    }
  }
  onMouseEnter() {
    if (this.overflowTooltip) {
      if (this.el.nativeElement.offsetWidth < this.el.nativeElement.scrollWidth) {
        this.instance = tippy(this.el.nativeElement, this.tippyOptions);
        this.show();
      }
    }
  }
  onMouseLeave() {
    if (this.overflowTooltip && this.instance) {
      this.instance.destroy();
    }
  }
  show() {
    this.instance.show();
  }
  hide() {
    setTimeout(() => this.instance.hide());
  }
  toggle() {
    if (this.open) {
      this.hide();
    } else {
      this.show();
    }
  }
  static {
    this.ɵfac = function TooltipDirective_Factory(t) {
      return new (t || TooltipDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TooltipDirective,
      selectors: [["", "solTooltip", ""]],
      hostBindings: function TooltipDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mouseenter", function TooltipDirective_mouseenter_HostBindingHandler() {
            return ctx.onMouseEnter();
          })("mouseleave", function TooltipDirective_mouseleave_HostBindingHandler() {
            return ctx.onMouseLeave();
          });
        }
      },
      inputs: {
        popoverTemplate: "popoverTemplate",
        content: "content",
        title: "title",
        trigger: "trigger",
        position: "position",
        maxWidth: "maxWidth",
        interactive: "interactive",
        closeOnOutsideClick: "closeOnOutsideClick",
        darkMode: "darkMode",
        arrow: "arrow",
        overflowTooltip: "overflowTooltip",
        appendTo: "appendTo"
      },
      exportAs: ["solTooltip"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipDirective, [{
    type: Directive,
    args: [{
      selector: '[solTooltip]',
      exportAs: 'solTooltip'
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    popoverTemplate: [{
      type: Input
    }],
    content: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    trigger: [{
      type: Input
    }],
    position: [{
      type: Input
    }],
    maxWidth: [{
      type: Input
    }],
    interactive: [{
      type: Input
    }],
    closeOnOutsideClick: [{
      type: Input
    }],
    darkMode: [{
      type: Input
    }],
    arrow: [{
      type: Input
    }],
    overflowTooltip: [{
      type: Input
    }],
    appendTo: [{
      type: Input
    }],
    onMouseEnter: [{
      type: HostListener,
      args: ['mouseenter']
    }],
    onMouseLeave: [{
      type: HostListener,
      args: ['mouseleave']
    }]
  });
})();
class TooltipModule {
  static {
    this.ɵfac = function TooltipModule_Factory(t) {
      return new (t || TooltipModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TooltipModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipModule, [{
    type: NgModule,
    args: [{
      declarations: [TooltipDirective],
      imports: [CommonModule],
      exports: [TooltipDirective]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TooltipDirective, TooltipModule };
